module.exports = __webpack_public_path__ + "static/img/122_TO8_1666.4d16734.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/122_TO8_1666.jpg
// module id = zCmd
// module chunks = 0